module.exports = __webpack_public_path__ + "media/brands/boro-fb00af69.png";